import { SimutechModule } from '../common/types'
import { toBoolean } from '../common/utils'

export const moduleClass = process.env.REACT_APP_MODULE_TYPE
export const moduleID: SimutechModule = process.env.REACT_APP_MODULE_ID as SimutechModule
export const moduleName: string = process.env.REACT_APP_MODULE_NAME

export const debugUsername: string = process.env.REACT_APP_USERNAME
export const debugUserID: string = process.env.REACT_APP_USERID
export const debugCompanyID: string = process.env.REACT_APP_COMPANY_ID
export const debugCompanyName: string = process.env.REACT_APP_COMPANY_NAME
export const debugLRSDBName: string = process.env.REACT_APP_DEBUG_LRS_DB_NAME

export const isDebug: boolean = toBoolean(process.env.REACT_APP_IS_DEBUG)
export const build: string = process.env.REACT_APP_WEB_BUILD_NUMBER
export const commitID: string = process.env.REACT_APP_WEB_COMMIT_ID.substring(0, 8)
export const environmentName: string = process.env.REACT_APP_ENVIRONMENT_NAME

export const xAPIURL: string = process.env.REACT_APP_XAPI_URL

export const lmsRequired: boolean = toBoolean(process.env.REACT_APP_LMS_REQUIRED)